// removed by extract-text-webpack-plugin
module.exports = {"container":"OptIn__container___WhpgS","title":"OptIn__title___3CKhX","description":"OptIn__description___1RQiq","descriptionError":"OptIn__descriptionError___2bvXc","acceptButton":"OptIn__acceptButton___19i2j","acceptedButton":"OptIn__acceptedButton___2cUTm","declineButton":"OptIn__declineButton___2a1uO","declinedButton":"OptIn__declinedButton___HLdw5","logo":"OptIn__logo___3790o","buttonRow":"OptIn__buttonRow___2dvRO","errorRow":"OptIn__errorRow___3svWQ"};


//////////////////
// WEBPACK FOOTER
// ./src/options/components/OptIn.css
// module id = 761
// module chunks = 0